import React from 'react';
import cx from 'classnames';

import { Text } from '../../../../../ui-kit';
import AccordionSection from './AccordionSection';
import PaymentSectionFooter from './PaymentSectionFooter';
import '../styles/_payment-section.scss';
























function PaymentSection({
  title,
  children,
  footerStartAdornment,
  footerTotalText,
  footerTotalValue,
  isFooterTotalValueChangeable,
  footerTotalValuePlaceholder,
  onFooterTotalValueChange,
  footerTotalText2,
  footerTotalValue2,
  isFooterTotalValue2Changeable,
  footerTotalValue2Placeholder,
  onFooterTotalValue2Change,
  isTitleString,
  hasBottomDivider,
  isExpandable,
  isOpenedByDefault,
  initialOpenIndex,
  className,
  ghost
}) {
  return (
    <div className={cx('payment-section', className)}>
      {isExpandable ?

      <AccordionSection
        title={title}
        initialOpenIndex={initialOpenIndex}
        footerStartAdornment={footerStartAdornment}
        hasBottomDivider={hasBottomDivider}
        footerTotalText={footerTotalText}
        footerTotalValue={footerTotalValue}
        isOpenedByDefault={isOpenedByDefault}
        ghost={ghost}>

            {children}
          </AccordionSection> :


      <>
            {isTitleString ?
        <Text className="payment-section__title" heading5>
                {title}
              </Text> :
        title}

            <div className="payment-section__body">
              {children &&
          <>
                  <div className="payment-section__body-content">
                    {children}
                  </div>

                  {hasBottomDivider && <hr className="payment-section__body-divider" />}
                </>}

              <PaymentSectionFooter
            prefixDagger={Boolean(children)}
            footerStartAdornment={footerStartAdornment}
            footerTotalText={footerTotalText}
            footerTotalValue={footerTotalValue}
            isFooterTotalValueChangeable={isFooterTotalValueChangeable}
            footerTotalValuePlaceholder={footerTotalValuePlaceholder}
            onFooterTotalValueChange={onFooterTotalValueChange} />

              {typeof footerTotalText2 !== 'undefined' && typeof footerTotalValue2 !== 'undefined' &&
          <PaymentSectionFooter
            prefixDagger={Boolean(children)}
            footerStartAdornment={footerStartAdornment}
            footerTotalText={footerTotalText2}
            footerTotalValue={footerTotalValue2}
            isFooterTotalValueChangeable={isFooterTotalValue2Changeable}
            footerTotalValuePlaceholder={footerTotalValue2Placeholder}
            onFooterTotalValueChange={onFooterTotalValue2Change} />}


            </div>
          </>}


    </div>);

}

export default PaymentSection;